<div class="tracking-page-delivery-promise-container" [formGroup]="formGroup">
  <pdq-card variant="popover" color="white" formGroupName="widgets">
    <div class="card" formGroupName="deliveryPromise">
      <div class="header-container">
        <div class="header-title-section">
          <pdq-heading element="h5">Delivery Promise</pdq-heading>
          <p class="header-description">Configure delivery date estimates on tracking page</p>
        </div>
      </div>

      <pdq-divider></pdq-divider>

      <div class="sub-cards">
        <div class="sub-card">
          <div class="toggle-row">
            <div class="toggle-row__text">
              <span class="toggle-row__label">Shipping Method Promise</span>
              <span class="toggle-row__badge">Primary</span>
            </div>
            <pdq-slide-toggle formControlName="showShippingMethodPromise"></pdq-slide-toggle>
          </div>
          <p class="toggle-row__subtext">
            Display the delivery date promised at checkout based on the chosen shipping method
          </p>

          @if (isShippingMethodPromiseEnabled) {
            <div class="nested-toggle">
              <div class="nested-toggle__line"></div>
              <div class="nested-toggle__content">
                <div class="toggle-row">
                  <div class="toggle-row__text">
                    <span class="toggle-row__label toggle-row__label--secondary">Expected late indicator</span>
                  </div>
                  <pdq-slide-toggle formControlName="showExpectedLateIndicator"></pdq-slide-toggle>
                </div>
                <p class="toggle-row__subtext">
                  Compare carrier updates against checkout promise. If expected late, show revised ETA with original
                  promise date.
                </p>
              </div>
            </div>
          }
        </div>

        <pdq-divider></pdq-divider>

        <div class="sub-card">
          <div class="toggle-row">
            <div class="toggle-row__text">
              <span class="toggle-row__label">Carrier ETA</span>
            </div>
            <pdq-slide-toggle formControlName="showCarrierETA"></pdq-slide-toggle>
          </div>
          <p class="toggle-row__subtext">Display the carrier's estimated delivery date (e.g., UPS, FedEx)</p>
        </div>

        @if (behaviorBannerText) {
          <div class="behavior-banner">
            <p class="behavior-banner__text">{{ behaviorBannerText }}</p>
          </div>
        }
      </div>
    </div>
  </pdq-card>
</div>
